/**
 * @generated SignedSource<<aa8d550febe6b9c696a9955dead3493c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type HubNoteDismissMutation$variables = Record<PropertyKey, never>;
export type HubNoteDismissMutation$data = {
  readonly dismissHubNote: {
    readonly me: {
      readonly hubNoteDismissed: boolean;
      readonly id: string;
    };
  };
};
export type HubNoteDismissMutation = {
  response: HubNoteDismissMutation$data;
  variables: HubNoteDismissMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "DismissHubReturn",
    "kind": "LinkedField",
    "name": "dismissHubNote",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Me",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hubNoteDismissed",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "HubNoteDismissMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "HubNoteDismissMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "4b1e34e35da1162bffe4db47d118533f",
    "id": null,
    "metadata": {},
    "name": "HubNoteDismissMutation",
    "operationKind": "mutation",
    "text": "mutation HubNoteDismissMutation {\n  dismissHubNote {\n    me {\n      id\n      hubNoteDismissed\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f323a09646e53560f52a45de2cf84077";

export default node;
